import { Badge } from '@dixa/lib-shared-habla';
import { LanguageContext } from 'lib-knowledge-management-common/contexts/language';
import { TranslationTitle } from 'lib-knowledge-management-common/graphql';
import { useContext } from 'react';
import { getFirstLanguage, hasDefaultLanguageTitle } from 'utils';

type NonDefaultLanguageBadgeProps = {
  titles: TranslationTitle[];
};
export function NonDefaultLanguageBadge({
  titles,
}: NonDefaultLanguageBadgeProps): JSX.Element {
  const {
    defaultLanguage: { languageId: defaultLanguageId },
  } = useContext(LanguageContext);
  const hasDefaultLanguage = hasDefaultLanguageTitle(titles, defaultLanguageId);

  const nonDefaultLanguageBadge = hasDefaultLanguage ? (
    <></>
  ) : (
    <>
      &nbsp;
      <Badge variant="info" size="small">
        {getFirstLanguage(titles).languageId}
      </Badge>
    </>
  );
  return nonDefaultLanguageBadge;
}
